export const CURRENCIES = [
    { code: 'ORIGINAL', symbol: '' },
    { code: 'AUD', symbol: '$' },
    { code: 'USD', symbol: '$' },
    { code: 'EUR', symbol: '€' },
    { code: 'GBP', symbol: '£' },
    { code: 'CAD', symbol: '$' },
    { code: 'NZD', symbol: '$' },
    { code: 'JPY', symbol: '¥' },
    { code: 'IDR', symbol: 'Rp' },
    { code: 'KRW', symbol: '₩' },
    { code: 'HKD', symbol: 'HK$' },
]
